import { foldLatinDiacritics } from '~/utils/search-text'

export function filterFacetOptions(options: CheckboxOption[], search: string): CheckboxOption[] {
  if (!search) {
    return options
  }

  const term = foldLatinDiacritics(search.toLowerCase())
  return options.filter((option) => foldLatinDiacritics(option.label.toLowerCase()).includes(term))
}

export function collapseFacetOptions(options: CheckboxOption[], selected: string[], limit: number): CheckboxOption[] {
  if (options.length <= limit) {
    return options
  }

  const isSelected = new Set(selected)
  return [...options]
    .sort((a, b) => (b.count ?? 0) - (a.count ?? 0))
    .filter((option, index) => index < limit || isSelected.has(option.value))
}
